import { createContext } from 'react';
import { UserRoleContextType } from './types';

const UserRoleContext = createContext<UserRoleContextType>({
  role: '',
} as UserRoleContextType);

export default UserRoleContext;
